module.exports = __webpack_public_path__ + "img/ico_simbolo-medicina.2b89718f.svg";